import React from "react";
import moment from "moment";
import get from "lodash/get";
import uniq from "lodash/uniq";
import cloneDeep from "lodash/cloneDeep";
import { connect } from "react-redux";
import {
  Alert,
  Icon,
  Layout,
  Input,
  Table,
  Button,
  Modal,
  Tooltip,
  message,
  Switch,
  Select,
  Checkbox,
  Tag, Col, Row,
} from "antd";
import { Link } from "react-router-dom";
import printJS from "print-js";

import ReturnedByPatientForm from "./ReturnedByPatientForm";
import DrugForm from "../../components/DrugForm/DrugForm";
import DrugShipForm from "../../components/DrugShipForm/DrugShipForm";
import UpdateDrugExpiryForm from "../../components/DrugForm/UpdateDrugExpiryForm";
import SendToPatientForm from "../../components/SendToPatientForm/SendToPatientForm";
import classes from "./DrugsEditor.css";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  getDrugSearchRequest,
  getDrugManagementSitesRequest,
  getDrugManagementToSitesRequest,
  activateDrugRequest,
  markDrugSentBackRequest,
  deactivateDrugRequest,
  drugSentToPatientRequest,
  drugReceivedByPatientRequest,
  drugReturnedByPatientRequest,
  drugNoLongerAvailableRequest,
  drugReadyToDispenseRequest,
  drugLostRequest,
  drugsSetStatusBulkRequest,
  drugResetOrphanedDrugRequest,
  drugReturnedDestroyedRequest,
  getDrugManagementDownload,
  markDrugQuarantinedRequest,
  markDrugReceivedRequest,
  markDrugReviewedRequest,
  drugPatientSentBackToFridgeRequest,
  drugItemEventsHistoryRequest,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import {
  getDrugCreatePermission,
  getDrugUpdatePermission,
  getDrugAccessPermissionDrugManagement,
  getDrugRequestTransferPermission,
  getDrugBulkActionsPermission,
  getUserTimezone,
  getUserShortTimezone,
  getDrugAllowTransferFromFridgeToPatient, getDrugExpiryDateEditPermission,
  getDrugReadPermission,
} from "../../reducers/user/selectors";
import { withParams } from "../../utils/url";
import mapped_statuses from "../../data/mappedStatus";
import { withNamespaces } from "react-i18next";
import {getFormErrorMessage} from "../../utils/errorHandler";

const routes = require("../../routes.json");

const { Content } = Layout;
const { Search } = Input;
const { Option } = Select;

class DrugsEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      drugs: [],
      nameSearch: null,
      errorMessage: null,
      responseMessage: null,
      isLoading: false,
      site: null,
      filter: null,
      order: "asc",
      currentPage: 1,
      total: 1,
      pageSize: 25,
      eventVisibleDropdown: false,
      eventsSelected: {},
      sortedInfo: {},
      drugEdit: null,
      filterBy: null,
      filterValue: null,
      filtersBy: ["location", "drug_status"],
      filtersValue: [],
      approvedSelected: null,
      shipDrug: false,
      sitesListFrom: [],
      sitesListTo: [],
      sitesFilter: [],
      dispensingSites: [],
      centralSites: [],
      statusFilters: [],
      drugItem: null,
      drugItemHistory: null,
      drug: null,
      trackingNumber: "",
      isSendingToPatient: false,
      isUpdateDrugExpiry: false,
      confirmAction: null,
      siteListLoading: false,
      selectedToSite: null,
      checkedItems: [],
      shiftDown: false,      
      showInactiveDrugs: false,
      actionComment: "",
      downloadingExample: false,
      returnedByPatientDrug: null,
    };
  }

  handleKeyDown = (event) => {
    if (event.keyCode === 16) {
      this.setState({
        shiftDown: true,
      });
    }
  };

  handleKeyUp = (event) => {
    if (event.keyCode === 16) {
      this.setState({
        shiftDown: false,
      });
    }
  };

  async componentDidMount() {
    this.onNameSearch();
    this.getSitesList();

    document.addEventListener("keydown", this.handleKeyDown);
    document.addEventListener("keyup", this.handleKeyUp);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
    document.removeEventListener("keyup", this.handleKeyUp);
  }

  getSitesList = async () => {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getDrugManagementSitesRequest();
      this.setState({
        sitesListFrom: get(data, "from").map((site) => ({
          value: get(site, "id"),
          label: get(site, "name"),
        })),
        sitesListTo: get(data, "to").map((site) => ({
          value: get(site, "id"),
          label: get(site, "name"),
        })),
        sitesFilter: get(data, "filter").map((site) => ({
          value: get(site, "id"),
          label: get(site, "name"),
        })),
        statusFilters: get(data, "statuses"),
        // dispensingSites: data.filter(site => get(site, 'site_type') === 'dispensing').map(site => ({ value: get(site, 'id'), label: get(site, 'name')})),
        // centralSites: data.filter(site => get(site, 'site_type') === 'central_pharmacy').map(site => ({ value: get(site, 'id'), label: get(site, 'name')}))
      });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        subject: null,

        errorMessage: getFormErrorMessage(e, true),
      });
    }

    setTimeout(() => {
      this.setState({ isLoading: false });
    }, 1000);
  };

  getToSitesList = async (selectedFromSiteId) => {
    this.setState({
      errorMessage: null,
      siteListLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getDrugManagementToSitesRequest(
        selectedFromSiteId
      );
      this.setState({
        // sitesListFrom: get(data, 'from').map(site => ({ value: get(site, 'id'), label: get(site, 'name')})),
        sitesListTo: get(data, "to").map((site) => ({
          value: get(site, "id"),
          label: get(site, "name"),
        })),
        siteListLoading: false,
        selectedToSite: null,
        // dispensingSites: data.filter(site => get(site, 'site_type') === 'dispensing').map(site => ({ value: get(site, 'id'), label: get(site, 'name')})),
        // centralSites: data.filter(site => get(site, 'site_type') === 'central_pharmacy').map(site => ({ value: get(site, 'id'), label: get(site, 'name')}))
      });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        subject: null,
        errorMessage: getFormErrorMessage(e, true),
      });
    }
    this.setState({ siteListLoading: false });
  };

  onNameSearch = async (value) => {
    this.setState(
      {
        nameSearch: value,
        filterBy: null,
        filterValue: null,
        eventsSelected: {},
        currentPage: 1,
      },
      this.getDrugs
    );
  };

  getDrugs = async (
    page = this.state.currentPage,
    per_page = this.state.pageSize
  ) => {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getDrugSearchRequest({
        nameSearch: this.state.nameSearch,
        page,
        per_page,
        order_direction: this.state.order,
        order_column: get(this.state, "sortedInfo.columnKey"),
        filter_by: this.state.filtersBy,
        filter_value: this.state.filtersValue,
        show_inactive: this.state.showInactiveDrugs
        // filter_approve: this.state.approvedSelected !== null ? this.state.approvedSelected : null,
      });

      if (Array.isArray(data.data)) {
        this.setState({
          checkedItems: [],
        });

        this.setState({
          drugs: data.data,
          total: data.total_pages * per_page,
          currentPage: page,
        });
      } else {
        this.setState({
          drugs: [data],
          total: 1 * per_page,
          currentPage: page,
        });
      }
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        drugs: null,
        errorMessage: getFormErrorMessage(e, true),
      });
    }

    setTimeout(() => {
      this.setState({ isLoading: false });
    }, 1000);
  };

  onNameChange = (e) => {
    this.setState({ nameSearch: e.target.value });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState(
      {
        isLoading: true,
        pageSize: pagination.pageSize,
        sortedInfo: sorter,
        order:
          get(sorter, "order") === "ascend"
            ? "asc"
            : get(sorter, "order") === "descend"
            ? "desc"
            : "asc",
      },
      () => this.getDrugs(pagination.current, pagination.pageSize)
    );
  };

  onDrugEdit = (drug) => () => {
    this.setState({ drugEdit: drug });
  };

  onDrugEditHide = () => {
    this.setState({ drugEdit: null });
  };

  onDrugEditSubmit = () => {
    this.setState({ drugEdit: null }, this.getDrugs);
  };

  addDrug = () => {
    this.setState({ drugEdit: {} });
  };

  shipDrug = () => {
    this.setState({ shipDrug: true });
  };

  shipDrugHide = () => {
    this.setState({ shipDrug: false });
  };

  onDrugShipSubmit = () => {
    this.getDrugs();
  };

  onDrugShitClose = () => {
    this.shipDrugHide();
  };

  onSwitchDrugActivation = (id, state) => async () => {
    try {
      if (state === "active") {
        await deactivateDrugRequest(id);
      } else {
        await activateDrugRequest(id);
      }

      message.success(this.props.i18n.t("Saved"));

      this.getDrugs();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(getFormErrorMessage(e, true));
      console.log(e);
    }
  };

  onDrugReceived = (id) => async () => {
    try {
      await markDrugReceivedRequest(id, get(this.state, "confirmAction.actionComment"));
      message.success(this.props.i18n.t("Saved"));

      this.getDrugs();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(getFormErrorMessage(e, true));
      console.log(e);
    }
  };

  onDrugReviewed = (id) => async () => {
    try {
      await markDrugReviewedRequest(id, get(this.state, "confirmAction.actionComment"));
      message.success(this.props.i18n.t("Saved"));

      this.getDrugs();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(getFormErrorMessage(e, true));
      console.log(e);
    }
  };

  onDrugQuarantined = (id) => async () => {
    try {

      await markDrugQuarantinedRequest(id, get(this.state, "confirmAction.actionComment"));
      message.success(this.props.i18n.t("Saved"));

      this.getDrugs();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(getFormErrorMessage(e, true));
      console.log(e);
    }
  };


  onDrugReadyToDispenseRequest = (id) => async () => {
    try {
      await drugReadyToDispenseRequest(id, get(this.state, "confirmAction.actionComment"));
      message.success(this.props.i18n.t("Saved"));
      this.onConfirmActionHide();
      this.getDrugs();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(getFormErrorMessage(e, true));
      console.log(e);
    }
  };

  onDrugResetOrphanedDrug = (id) => async () => {
    try {
      await drugResetOrphanedDrugRequest(id, get(this.state, "confirmAction.actionComment"));
      message.success(this.props.i18n.t("Orphaned drug item reset to first location in chain."));
      this.onConfirmActionHide();
      this.getDrugs();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(getFormErrorMessage(e, true));
      console.log(e);
    }
  };

  onDrugSentToPatientRequest = (id) => async () => {
    try {
      await drugSentToPatientRequest(id, get(this.state, "confirmAction.actionComment"));
      message.success(this.props.i18n.t("Saved"));

      this.getDrugs();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(getFormErrorMessage(e, true));
      console.log(e);
    }
  };

  onDrugReceivedByPatientRequestRequest = (id) => async () => {
    try {
      await drugReceivedByPatientRequest(id, get(this.state, "confirmAction.actionComment"));
      message.success(this.props.i18n.t("Saved"));

      this.getDrugs();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(getFormErrorMessage(e, true));
      console.log(e);
    }
  };

  onDrugReturnedByPatientRequest = (id) => async () => {
    try {
      await drugReturnedByPatientRequest(id, get(this.state, "confirmAction.actionComment"));
      message.success(this.props.i18n.t("Saved"));

      this.getDrugs();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(getFormErrorMessage(e, true));
      console.log(e);
    }
  };

  onDrugSentBack = (id) => async () => {
    try {
      await markDrugSentBackRequest(id, get(this.state, "confirmAction.actionComment"));
      message.success(this.props.i18n.t("Saved"));

      this.getDrugs();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(getFormErrorMessage(e, true));
      console.log(e);
    }
  };


  onDrugNoLongerAvailableRequest = (id) => async () => {
    try {
      await drugNoLongerAvailableRequest(id, get(this.state, "confirmAction.actionComment"));
      message.success(this.props.i18n.t("Saved"));

      this.getDrugs();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(getFormErrorMessage(e, true));
      console.log(e);
    }
  };

  onDrugReturnedDestroyed = (id) => async () => {
    try {
      await drugReturnedDestroyedRequest(id, get(this.state, "confirmAction.actionComment"));
      message.success(this.props.i18n.t("Saved"));

      this.getDrugs();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(getFormErrorMessage(e, true));
      console.log(e);
    }
  };

  onDrugLostRequest = (id) => async () => {
    try {
      await drugLostRequest(id, get(this.state, "confirmAction.actionComment"));
      message.success(this.props.i18n.t("Saved"));

      this.getDrugs();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(getFormErrorMessage(e, true));
      console.log(e);
    }
  };

  onDrugPatientSentBackToFridgeRequest = (id) => async () => {
    try {
      await drugPatientSentBackToFridgeRequest(id, get(this.state, "confirmAction.actionComment"));
      message.success(this.props.i18n.t("Saved"));

      this.getDrugs();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(get(e, "response.data.error", "Error"));
      console.log(e);
    }
  };

  onDrugPrintRequest = (dataJSON) => async () => {
    const from_location = get(dataJSON, "from_location.name");
    const to_location = get(dataJSON, "to_location.name");
    const vial_records = get(dataJSON, "vial_records");
    const total_vials = get(dataJSON, "total_vials");

    console.log("printing ....");
    printJS({
      printable: vial_records,
      properties: [{ field: "vial_number", displayName: "Drug #" }],
      type: "json",
      header: `<h3 class="custom-h3">${this.props.i18n.t(
        "NamespaceDrugsEditor:From Location"
      )}: ${from_location} <br/> ${this.props.i18n.t(
        "NamespaceDrugsEditor:To Location"
      )}: ${to_location} <br/> ${this.props.i18n.t(
        "NamespaceDrugsEditor:Number of drug ids"
      )}: ${total_vials}</h3>`,
      style: ".custom-h3 { color: red; }",
    });
    return false;
  };

  handleFilterChange = (index) => (value) => {
    this.setState((state) => {
      const filtersBy = cloneDeep(state.filtersBy);
      const filtersValue = cloneDeep(state.filtersValue);
      filtersBy[index] = value;
      delete filtersValue[index];
      return { filtersBy, filtersValue };
    });
  };
  handleFilterValueChange = (index) => (value) => {
    this.setState((state) => {
      const filtersValue = cloneDeep(state.filtersValue);
      filtersValue[index] = value;
      return { filtersValue, currentPage: 1 };
    }, this.getDrugs);
  };

  clearFilter = (index) => () => {
    this.setState((state) => {
      const filtersBy = cloneDeep(state.filtersBy);
      const filtersValue = cloneDeep(state.filtersValue);

      filtersBy.splice(index, 1);
      filtersValue.splice(index, 1);

      return { filtersBy, filtersValue, currentPage: 1 };
    }, this.getDrugs);
  };

  clearFilters = () => {
    this.setState({ nameSearch: null, filtersValue: [], currentPage: 1 }, this.getDrugs);
  };

  onSelectApprovedStatus = (approvedStatusType) => () => {
    let status;
    const { approvedSelected } = this.state;

    if (approvedSelected === null && approvedStatusType === "approved") {
      status = false;
    }
    if (approvedSelected === true && approvedStatusType === "approved") {
      status = false;
    }
    if (approvedSelected === false && approvedStatusType === "approved") {
      status = null;
    }

    if (approvedSelected === null && approvedStatusType === "unapproved") {
      status = true;
    }
    if (approvedSelected === false && approvedStatusType === "unapproved") {
      status = true;
    }
    if (approvedSelected === true && approvedStatusType === "unapproved") {
      status = null;
    }

    this.setState((_) => ({ approvedSelected: status, currentPage: 1 }), this.getDrugs);
  };

  openDrugItem = (drugItem)  =>  async () => {
    this.setState({ drugItem });
    const data = await drugItemEventsHistoryRequest(drugItem.id);
    if (data){
      this.setState({ drugItemHistory: data.data });
    }
  };

  closeDrugItem = () => {
    this.setState({ drugItem: null });
    this.setState({ drugItemHistory: null });
  };

  onChangeLocationFilter = (value) => {
    this.setState((state) => {
      const filtersValue = [...state.filtersValue];
      filtersValue[0] = value;

      return { filtersValue, currentPage: 1 };
    }, this.getDrugs);
  };

  onChangeDrugStatusFilter = (value) => {
    this.setState((state) => {
      const filtersValue = [...state.filtersValue];
      filtersValue[1] = value;

      return { filtersValue, currentPage: 1 };
    }, this.getDrugs);
  };

  onFromChange = async (value) => {
    try {
      await this.getToSitesList(value);
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(getFormErrorMessage(e, true));
      console.log(e);
    }
  };

  onToChange = (value) => () => {
    this.setState({
      selectedToSite: value,
    });
  };

  onDrugSentToPatientInit = (drug) => () => {
    this.setState({
      drug,
      isSendingToPatient: true,
    });
  };

  onDrugSendToPatientSubmit = () => {
    this.sendingToPatientHide();
    this.getDrugs();
  };

  sendingToPatientHide = () => {
    this.setState({
      drug: null,
      isSendingToPatient: false,
      trackingNumber: null,
    });
  };

  onConfirmActionHide = () => {
    this.setState({
      confirmAction: null,
    });
  };

  bulkDrugAction = async (status) => {
    this.setState({ checkedItems: [] });
    try {
      await drugsSetStatusBulkRequest({
        locationId: get(this.state.checkedItems[0], "location.id"),
        vialIds: this.state.checkedItems.map((item) => get(item, "id")),
        fromDrugStatus: get(this.state.checkedItems[0], "drug_status"),
        actionOnDrug: status,
        actionComment: get(this.state, "confirmAction.actionComment", null),
      });
      message.success(this.props.i18n.t("Saved"));
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      if (get(e, "response.data.errors")) {
        Object.keys(get(e, "response.data.errors")).forEach((errorFieldKey) => {
          message.error(get(e, `response.data.errors.${errorFieldKey}`));
        });
      }
      if (get(e, "response.data.error")) {
        message.error(getFormErrorMessage(e));
      }

      // console.log(get(e, "response.data.error", "Error"));
    } finally {
      this.getDrugs();
    }
  };

  downloadExample = async () => {
    try {
      this.setState({ downloadingExample: true });

      const response = await getDrugManagementDownload();
      const data = response.data;

      const blob = new Blob([data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `drugs_with_expiry_date.csv`;
      link.click();

      this.setState({ downloadingExample: false });
    } catch (e) {
      console.log(e);
    }
  };


  render() {
    const {
      errorMessage,
      isLoading,
      responseMessage,
      nameSearch,
      drugs,
      currentPage,
      total,
      pageSize,
      drugEdit,
      sortedInfo,
      shipDrug,
      centralSites,
      sitesListFrom,
      sitesListTo,
      drugItem,
      filtersValue,
      drug,
      isSendingToPatient,
      confirmAction,
      checkedItems,
      shiftDown,
      statusFilters,
      sitesFilter,
      returnedByPatientDrug,
      isUpdateDrugExpiry,
      downloadingExample,
      showInactiveDrugs,
      actionComment,
      drugItemHistory,
    } = this.state;
    const {
      drugCreatePermission,
      drugUpdatePermission,
      drugAccessPermissionDrugManagement,
      drugRequestTransferPermission,
      drugReadPermission,
    } = this.props;

    const drugNotAllowedForSelection = (primaryDrug, drug) => {
      const checkboxAllowedLocationId = get(primaryDrug, "location.id");

      const checkboxAllowedStatus = get(primaryDrug, "drug_status");
      let result = get(drug, "subject_id") || (
        checkboxAllowedLocationId &&
        checkboxAllowedStatus &&
        (get(drug, "location.id") !== checkboxAllowedLocationId ||
          get(drug, "drug_status") !== checkboxAllowedStatus)
      );

      return result
    };
    let columns = [
      {
        dataIndex: "checkbox",
        key: "checkbox",
        title: () =>
          this.props.drugBulkActionsPermission &&
          drugs &&
          drugs.length > 0 && (
            <Checkbox
              onChange={(e) => {
                if (e.target.checked) {
                  this.setState(({ checkedItems }) => ({
                    checkedItems: uniq([
                      checkedItems[0] || drugs[0],
                      ...drugs.reduce(
                        (result, item) =>
                          !drugNotAllowedForSelection(
                            checkedItems[0] || drugs[0],
                            item
                          )
                            ? [...result, item]
                            : result,
                        []
                      ),
                    ]),
                  }));
                } else {
                  this.setState(({ checkedItems }) => ({
                    checkedItems: [],
                  }));
                }
              }}
            />
          ),
        render: (val, drugItem, index) => (
          <div>
            {this.props.drugBulkActionsPermission && (
              <Checkbox
                disabled={drugNotAllowedForSelection(checkedItems[0], drugItem)}
                onChange={(e) => {
                  if (checkedItems.length && shiftDown) {
                    const lastCheckedItemIndex = drugs.findIndex(
                      (item) =>
                        item.id === checkedItems[checkedItems.length - 1].id
                    );

                    let newItems = [];

                    if (lastCheckedItemIndex < index) {
                      newItems = drugs.reduce((result, item, itemIndex) => {
                        return itemIndex > lastCheckedItemIndex &&
                          itemIndex <= index &&
                          !drugNotAllowedForSelection(checkedItems[0], item)
                          ? [...result, item]
                          : result;
                      }, []);
                    } else {
                      newItems = drugs.reduce((result, item, itemIndex) => {
                        return itemIndex < lastCheckedItemIndex &&
                          itemIndex >= index &&
                          !drugNotAllowedForSelection(checkedItems[0], item)
                          ? [...result, item]
                          : result;
                      }, []);
                    }

                    this.setState(({ checkedItems }) => ({
                      checkedItems: uniq([...checkedItems, ...newItems]),
                    }));
                  } else {
                    this.setState(({ checkedItems }) => ({
                      checkedItems: e.target.checked
                        ? uniq([...checkedItems, drugItem])
                        : uniq(
                            checkedItems.filter(
                              (item) => item.id !== drugItem.id
                            )
                          ),
                    }));
                  }
                }}
                checked={
                  checkedItems.findIndex((item) => item.id === drugItem.id) > -1
                }
              />
            )}
          </div>
        ),
      },
      {
        dataIndex: "vial_number",
        key: "vial_number",
        title: this.props.i18n.t("Drug #"),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "vial_number" && sortedInfo.order,
        render: (val, drugItem) => (
          <div>
            <Tooltip
              placement="topLeft"
              title={this.props.i18n.t(
                "NamespaceDrugsEditor:View event summary"
              )}
            >
              <span
                className={classes.vialLink}
                onClick={this.openDrugItem(drugItem)}
              >
                {val}
              </span>
            </Tooltip>
            &nbsp;&nbsp;&nbsp;
            {drugItem.drug_status === "expired" && <Tag color="#f50">{this.props.i18n.t("Expired")}</Tag>}
          </div>
        ),
      },
      {
        dataIndex: "subject",
        key: "subject_id",
        title: this.props.i18n.t("Subject ID"),
        render: (val) => (
          <Link
            to={withParams(routes.admin.patientProfileSingle, {
              subjectID: get(val, "profile.code"),
            })}
          >
            {get(val, "code")}
          </Link>
        ),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "subject_id" && sortedInfo.order,
      },
      {
        dataIndex: "expiry_date",
        key: "expiry_date",
        title: "Expire Date",
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "expiry_date" && sortedInfo.order,
        render: (val) => (
          <span>
            {val
              ? `${moment
                .utc(val)
                .format("YYYY-MM-DD")}`
              : "No data"}{" "}
          </span>
        ),
      },
      // {
      //   dataIndex: "expiry_date",
      //   key: "expiry_date",
      //   title: this.props.i18n.t('Expiry date'),
      //   sorter: true,
      //   sortOrder: get(sortedInfo, 'columnKey') === 'expiry_date' && sortedInfo.order,
      // },
      {
        dataIndex: "drug_status",
        key: "drug_status",
        title: this.props.i18n.t("Drug status"),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "drug_status" && sortedInfo.order,
        render: (val) => (
          <div style={{ maxWidth: "130px" }}>
            {
              mapped_statuses(this.props.i18n)[val]
            }
          </div>
        ),
      },
      {
        dataIndex: "location",
        key: "location",
        title: this.props.i18n.t("Location"),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "location" && sortedInfo.order,
        render: (val, drug) => (
          <div style={{ maxWidth: "130px" }}>
            <span>{get(val, "name")}</span>
          </div>
        ),
      },
      {
        dataIndex: "drug_location_status",
        key: "drug_location_status",
        title: this.props.i18n.t("NamespaceDrugsEditor:Location Status"),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "drug_location_status" &&
          sortedInfo.order,
        render: (val, drug) => (
          <div>
            {val}

            {get(drug, "permitted_actions", []).includes(
                "transfer_action"
              ) && (
                <span style={{ color: "#8b8b8d" }}> <br/> ({this.props.i18n.t("NamespaceDrugsEditor:can be transferred")})</span>
              )
            }
            {get(drug, "permitted_actions", []).includes(
                "reset_orphaned_drug_action"
              ) && (
                <span style={{ color: "#943c3c" }}> <br/> ({this.props.i18n.t("NamespaceDrugsEditor:orphaned drug item")})</span>
              )
            }
          </div>
        ),
      },
      {
        dataIndex: "id",
        key: "id",
        title: this.props.i18n.t("Actions"),
        render: (val, drug) => (
          <div className={classes.actions}>
            {drugReadPermission && (
              <Tooltip
                placement="topLeft"
                title={this.props.i18n.t("NamespaceDrugsEditor:Edit Drug")}
              >
                <Icon
                  type="edit"
                  theme="filled"
                  className={classes.iconEdit}
                  onClick={this.onDrugEdit(drug)}
                />
              </Tooltip>
            )}
            &nbsp; &nbsp;
            <div>
              <b className={classes.switchLabel}>State</b>
              <br />
              <Tooltip
                placement="topLeft"
                title={this.props.i18n.t(
                  "NamespaceDrugsEditor:Activate / Deactivate Drug"
                )}
              >
                <Switch
                  className={classes.reactivateBtn}
                  checked={drug.state === "active"}
                  disabled={!get(drug, "permitted_actions", []).includes(
              "activate_action"
            ) }
                  onChange={this.onSwitchDrugActivation(val, drug.state)}
                />
              </Tooltip>
              &nbsp; &nbsp;
            </div>

            <div className={classes.buttonWrapper}>

              {get(drug, "permitted_actions", []).includes(
                "received_action"
              ) && (
                  <Button
                    type="primary"
                    size="small"
                    onClick={() =>
                      this.setState({
                        confirmAction: {
                          id: val,
                          title: this.props.i18n.t("Accept"),
                          action: this.onDrugReceived(val),
                          drug: drug,
                        },
                      })
                    }
                  >
                    {this.props.i18n.t("Accept")}
                  </Button>
              )}
              {get(drug, "permitted_actions", []).includes(
                "review_action"
              ) && (
                  <Button
                    type="primary"
                    size="small"
                    onClick={() =>
                      this.setState({
                        confirmAction: {
                          id: val,
                          title: this.props.i18n.t("NamespaceDrugsEditor:Review"),
                          action: this.onDrugReviewed(val),
                          drug: drug,
                        },
                      })
                    }
                  >
                    {this.props.i18n.t("NamespaceDrugsEditor:Review")}
                  </Button>
              )}

              {get(drug, "permitted_actions", []).includes(
                "ready_to_dispense_action"
              ) && (
                  <Button
                    type="default"
                    size="small"
                    onClick={() =>
                      this.setState({
                        confirmAction: {
                          id: val,
                          title: this.props.i18n.t("Ready to dispense"),
                          action: this.onDrugReadyToDispenseRequest(val),
                          drug: drug,
                        },
                      })
                    }
                  >
                    {this.props.i18n.t("Ready to dispense")}
                  </Button>
              )}

            {drug.drug_status === "allocated" &&
                this.props.drugAllowTransferFromFridgeToPatient && (
                    <Button
                      type="primary"
                      size="small"
                      onClick={this.onDrugSentToPatientInit(drug)}
                    >
                      {this.props.i18n.t("NamespaceDrugsEditor:Send to patient")}
                    </Button>
                )}

              {drug.drug_status === "courier_sent_to_the_patient" &&
                this.props.drugAllowTransferFromFridgeToPatient && (
                    <Button
                      type="primary"
                      size="small"
                      onClick={() =>
                        this.setState({
                          confirmAction: {
                            id: val,
                            title: this.props.i18n.t("NamespaceDrugsEditor:Delivered to patient"),
                            action: this.onDrugReceivedByPatientRequestRequest(
                              val
                            ),
                            drug: drug,
                          },
                        })
                      }
                    >
                      {this.props.i18n.t("NamespaceDrugsEditor:Delivered to patient")}
                    </Button>
                )}
              {drug.drug_status === "received_by_patient" &&
                this.props.drugAllowTransferFromFridgeToPatient && (
                    <Button
                      type="primary"
                      size="small"
                      onClick={() =>
                        this.setState({
                          returnedByPatientDrug: drug,
                        })
                      }
                    >
                      {this.props.i18n.t("NamespaceDrugsEditor:Returned by patient")}
                    </Button>
                )}
              {/*TODO handle returned_by_patient*/}
              {drug.drug_status === "returned_by_patient" && (
                  <Button
                    type="primary"
                    size="small"
                    onClick={() =>
                      this.setState({
                        confirmAction: {
                          id: val,
                          title: this.props.i18n.t("NamespaceDrugsEditor:Sent back to") + " " + this.props.i18n.t("NamespaceDrugsEditor:fridge"),
                          action: this.onDrugPatientSentBackToFridgeRequest(val),
                          drug: drug,
                        },
                      })
                    }
                  >
                    {this.props.i18n.t("NamespaceDrugsEditor:Sent back to")}{" "}
                    {this.props.i18n.t("NamespaceDrugsEditor:fridge")}
                  </Button>
              )}

              {drug.drug_status.includes("in_transit") && !get(drug, "permitted_actions", []).includes(
                "reset_orphaned_drug_action"
              ) &&
                drug.drug_transfer_id &&
                drug.drug_transfer_list && (
                  <Button
                    type="primary"
                    size="small"
                    onClick={() =>
                      this.setState({
                        confirmAction: {
                          id: val,
                          title: this.props.i18n.t(
                            "Print"
                          ),
                          action: this.onDrugPrintRequest(
                            drug.drug_transfer_list
                          ),
                          drug: drug,
                        },
                      })
                    }
                  >
                    {this.props.i18n.t(
                            "Print"
                          )}
                  </Button>
                )}

              {get(drug, "permitted_actions", []).includes(
                "lost_action"
              ) && (
                  <Button
                    type="default"
                    size="small"
                    onClick={() =>
                      this.setState({
                        confirmAction: {
                          id: val,
                          title: this.props.i18n.t("Lost"),
                          action: this.onDrugLostRequest(val),
                          drug: drug,
                        },
                      })
                    }
                  >
                    {this.props.i18n.t("Lost")}
                  </Button>
              )}
              


              {get(drug, "permitted_actions", []).includes(
                "send_back_action"
              ) && (
                  <Button
                    type="default"
                    size="small"
                    onClick={() =>
                      this.setState({
                        confirmAction: {
                          id: val,
                          title: this.props.i18n.t("NamespaceDrugsEditor:Send back to ") +  drug.previous_site,
                          action: this.onDrugSentBack(val),
                          drug: drug,
                        },
                      })
                    }
                  >
                    {this.props.i18n.t("NamespaceDrugsEditor:Send back to ")} {drug.previous_site}
                  </Button>
              )}

              {get(drug, "permitted_actions", []).includes(
                "quarantine_action"
              ) && (
                  <Button
                    type="default"
                    size="small"
                    onClick={() =>
                      this.setState({
                        confirmAction: {
                          id: val,
                          title: this.props.i18n.t(
                            "NamespaceDrugsEditor:Mark as quarantined"
                          ),
                          action: this.onDrugQuarantined(val),
                          drug: drug,
                        },
                      })
                    }
                  >
                    {this.props.i18n.t("NamespaceDrugsEditor:Mark as quarantined")}
                  </Button>
              )}

              {get(drug, "permitted_actions", []).includes(
                "unavailable_action"
              ) && (
                    <Button
                      type="default"
                      size="small"
                      onClick={() =>
                        this.setState({
                          confirmAction: {
                            id: val,
                            title: this.props.i18n.t(
                              "NamespaceDrugsEditor:Unavailable / Damaged"
                            ),
                            action: this.onDrugNoLongerAvailableRequest(val),
                            drug: drug,
                          },
                        })
                      }
                    >
                      {this.props.i18n.t(
                        "NamespaceDrugsEditor:Unavailable / Damaged"
                      )}
                    </Button>
                )}
              {get(drug, "permitted_actions", []).includes(
                "returned_destroyed_action"
              ) && (
                  <Button
                    type="default"
                    size="small"
                    onClick={() =>
                      this.setState({
                        confirmAction: {
                          id: val,
                          title: this.props.i18n.t(
                            "NamespaceDrugsEditor:Returned / Destroyed"
                          ),
                          action: this.onDrugReturnedDestroyed(val),
                          drug: drug,
                        },
                      })
                    }
                  >
                    {this.props.i18n.t(
                            "NamespaceDrugsEditor:Mark as Returned / Destroyed"
                          )}
                  </Button>
              )}

              {get(drug, "permitted_actions", []).includes(
                "reset_orphaned_drug_action"
              ) && (
                  <Button
                    type="danger"
                    size="small"
                    onClick={() =>
                      this.setState({
                        confirmAction: {
                          id: val,
                          title: this.props.i18n.t("NamespaceDrugsEditor: Reset the orphaned drug item to the first location in chain with a QUARANTINED status."),
                          action: this.onDrugResetOrphanedDrug(val),
                          drug: drug,
                        },
                      })
                    }
                  >
                    {this.props.i18n.t("NamespaceDrugsEditor:Reset orphaned drug.")}
                  </Button>
              )}

            </div>
          </div>
        ),
      },
    ];

    if (drugAccessPermissionDrugManagement) {
      columns.splice(3, 0, {
        dataIndex: "drug_type",
        key: "drug_type",
        title: this.props.i18n.t("NamespaceDrugsEditor:Drug type"),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "drug_type" && sortedInfo.order,
        render: (val) => val && val.replace(/_/g, " "),
      });
    }

    const selectedBulkStatus = get(this.state.checkedItems[0], "drug_status");
    const selectedPermittedActions = get(this.state.checkedItems[0], "permitted_actions", []);
    const selectedBulkVialNumbers = []
    if (this.state.checkedItems){
      this.state.checkedItems.forEach((item) => selectedBulkVialNumbers.push(get(item, 'vial_number')))
    }

    return (
      <div>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t("NamespaceDrugsEditor:Drug management")}
            </h3>

            <div className={classes.searchWrapper}>
              <label className={classes.searchWrapperSearch}>
                <b className={classes.searchWrapperLabel}>
                  {this.props.i18n.t("SEARCH")}
                </b>
                <Search
                  placeholder={this.props.i18n.t(
                    "NamespaceDrugsEditor:By Drug #"
                  )}
                  enterButton={this.props.i18n.t("Search")}
                  size="large"
                  onSearch={this.onNameSearch}
                  value={nameSearch}
                  onChange={this.onNameChange}
                  style={{maxWidth: "500px"}}
                  disabled={isLoading}
                />
              </label>

              <div className={classes.wrapperLocationFilter}>
                <b className={classes.searchWrapperLabel}>
                  {this.props.i18n.t("NamespaceDrugsEditor:Filter by location")}
                </b>
                <br/>
                <div>
                  <Select
                    style={{width: "300px"}}
                    onChange={this.onChangeLocationFilter}
                    value={filtersValue[0]}
                    disabled={isLoading}
                  >
                    {sitesFilter.map((item) => (
                      <Option value={item.value} key={item.value}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                  {/* <Radio.Group
                    options={
                      drugCreatePermission
                        ? [...sitesListTo, ...sitesListFrom]
                        : sitesListFrom
                    }
                    onChange={this.onChangeLocationFilter}
                    value={filtersValue[0]}
                  /> */}
                </div>
              </div>

              <div className={classes.wrapperLocationFilter}>
                <b className={classes.searchWrapperLabel}>
                  {this.props.i18n.t(
                    "NamespaceDrugsEditor:Filter by drug status"
                  )}
                </b>
                <br/>
                <div>
                  <Select
                    style={{width: "400px"}}
                    onChange={this.onChangeDrugStatusFilter}
                    value={filtersValue[1]}
                    disabled={isLoading}
                  >
                    {statusFilters.map((value) => (
                      <Option value={value} key={value}>
                        {
                          mapped_statuses(this.props.i18n)[value]
                        }
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>

              {!isLoading && (
                <span
                  className={classes.clearButton}
                  onClick={this.clearFilters}
                >
                  {this.props.i18n.t("Clear")}
                </span>
              )}
            </div>
            <div style={{margin: "0"}}>
              <Checkbox
                onChange={(e) => {
                  this.setState(
                    {showInactiveDrugs: e.target.checked, currentPage: 1},
                    this.getDrugs
                  );
                }}
                checked={showInactiveDrugs === true}
                style={{margin: "0 0 20px"}}
              >
                {this.props.i18n.t("NamespaceSettingsConsent:Show Inactive drugs")}
              </Checkbox>
            </div>

              {errorMessage && (
                <Alert
                  type="error"
                  message={errorMessage}
                  className={classes.alert}
                />
              )}

              {responseMessage && (
                <Alert
                  type="success"
                  message={responseMessage}
                  className={classes.alert}
                />
              )}

              <div className={classes.actionWrapper}>
                {drugCreatePermission && (
                  <div>
                    <Button type="primary" onClick={this.addDrug}>
                      {this.props.i18n.t("Upload drugs")}
                    </Button>
                  </div>
                )}
                {drugRequestTransferPermission && (
                  <div>
                    <Button type="primary" onClick={this.shipDrug}>
                      {this.props.i18n.t("NamespaceDrugsEditor:Ship the drug")}
                    </Button>
                  </div>
                )}

                {this.props.getDrugExpiryDateEditPermission && (
                  <div>
                    <Button
                      type="primary"
                      onClick={() => {
                        this.setState({
                          isUpdateDrugExpiry: true,
                        });
                      }}
                    >
                      {this.props.i18n.t(
                        "NamespaceDrugsEditor:Update drug expiry date"
                      )}
                    </Button>
                  </div>
                )}

                {drugReadPermission && (
                  <div>
                    <Button
                      type="primary"
                      onClick={this.downloadExample}
                      loading={downloadingExample}
                    >{this.props.i18n.t(
                      "NamespaceDrugsEditor:Download Drugs"
                    )}
                    </Button>
                  </div>
                )}

                {selectedBulkStatus && (
                  <div
                    style={{
                      position: "fixed",
                      padding: "1rem 3rem",
                      borderTop: "1px solid #eee",
                      boxShadow: "0 25px 50px 12px rgba(0,0,0,.25)",
                      bottom: 0,
                      left: 0,
                      width: "100%",
                      zIndex: 99,
                      background: "rgba(255,255,255,0.95)",
                    }}
                  >
                    <div
                      style={{display: "flex", justifyContent: "space-between"}}
                    >
                      <p style={{fontWeight: "bold", fontSize: "0.8rem"}}>
                        Bulk Actions:{" "}
                        <span style={{color: "#999"}}>
                        {this.state.checkedItems &&
                          this.state.checkedItems.length}{" "}
                          {this.props.i18n.t("selected")}
                      </span>
                      </p>
                      <button
                        style={{
                          outline: "none",
                          cursor: "pointer",
                          background: "transparent",
                          padding: 0,
                          margin: 0,
                          border: "none",
                          color: "#aaa",
                        }}
                        onClick={() => this.setState({checkedItems: []})}
                      >
                        <Icon type="close"/>
                      </button>
                    </div>
                    <div style={{display: "flex"}}>

                      {selectedPermittedActions.includes(
                        "received_action"
                      ) && (
                        <div>
                          <Button
                            type="primary"
                            onClick={() =>
                              this.setState({
                                confirmAction: {
                                  title: this.props.i18n.t("Accept"),
                                  action: () => this.bulkDrugAction("received_action"),
                                  selectedBulkVialNumbers: selectedBulkVialNumbers
                                },
                              })
                            }
                          >
                            {this.props.i18n.t("Accept")}
                          </Button>
                        </div>
                      )}                      
                      
                      {selectedPermittedActions.includes(
                        "review_action"
                      ) && (
                        <div>
                          <Button
                            type="primary"
                            onClick={() =>
                              this.setState({
                                confirmAction: {
                                  title: this.props.i18n.t(
                                    "NamespaceDrugsEditor:Review"
                                  ),
                                  action: () => this.bulkDrugAction("review_action"),
                                  selectedBulkVialNumbers: selectedBulkVialNumbers
                                },
                              })
                            }
                          >
                            {this.props.i18n.t("NamespaceDrugsEditor:Review")}
                          </Button>
                        </div>
                      )}

                      {selectedPermittedActions.includes(
                        "ready_to_dispense_action"
                      ) && (
                          <div>
                            <Button
                              type="primary"
                              onClick={() =>
                                this.setState({
                                  confirmAction: {
                                    title: this.props.i18n.t(
                                      "NamespaceDrugsEditor:Ready to dispense"
                                    ),
                                    action: () =>
                                      this.bulkDrugAction(
                                        "ready_to_dispense_action"
                                      ),
                                    selectedBulkVialNumbers: selectedBulkVialNumbers
                                  },
                                })
                              }
                            >
                              {this.props.i18n.t(
                                "NamespaceDrugsEditor:Ready to dispense"
                              )}
                            </Button>
                          </div>
                        )}

                      {selectedBulkStatus.includes("in_transit") && (
                        <div>
                          <Button
                            type="default"
                            onClick={() =>
                              this.setState({
                                confirmAction: {
                                  title: this.props.i18n.t("Lost"),
                                  action: () => this.bulkDrugAction("lost_action"),
                                  selectedBulkVialNumbers: selectedBulkVialNumbers
                                },
                              })
                            }
                          >
                            {this.props.i18n.t("Lost")}
                          </Button>
                        </div>
                      )}

                      {selectedPermittedActions.includes(
                        "quarantine_action"
                      ) && (
                        <div>
                          <Button
                            type="default"
                            onClick={() =>
                              this.setState({
                                confirmAction: {
                                  title: this.props.i18n.t(
                                    "NamespaceDrugsEditor:Mark as quarantined"
                                  ),
                                  action: () =>
                                    this.bulkDrugAction("quarantine_action"),
                                  selectedBulkVialNumbers: selectedBulkVialNumbers
                                },
                              })
                            }
                          >
                            {this.props.i18n.t(
                              "NamespaceDrugsEditor:Mark as quarantined"
                            )}
                          </Button>
                        </div>
                      )}

                      {selectedPermittedActions.includes(
                        "send_back_action"
                      ) && (
                        <div>
                          <Button
                            type="default"
                            onClick={() =>
                              this.setState({
                                confirmAction: {
                                  title: this.props.i18n.t(
                                    "NamespaceDrugsEditor:Send back"
                                  ),
                                  action: () =>
                                    this.bulkDrugAction("send_back_action"),
                                  selectedBulkVialNumbers: selectedBulkVialNumbers
                                },
                              })
                            }
                          >
                            {this.props.i18n.t(
                              "NamespaceDrugsEditor:Send back"
                            )}
                          </Button>
                        </div>
                      )}

                      {selectedPermittedActions.includes(
                        "unavailable_action"
                      ) && (
                          <div>
                            <Button
                              type="default"
                              onClick={() =>
                                this.setState({
                                  confirmAction: {
                                    title: this.props.i18n.t(
                                      "NamespaceDrugsEditor:Mark as Unavailable / Damaged"
                                    ),
                                    action: () =>
                                      this.bulkDrugAction(
                                        "unavailable_action"
                                      ),
                                    selectedBulkVialNumbers: selectedBulkVialNumbers
                                  },
                                })
                              }
                            >
                              {this.props.i18n.t(
                                "NamespaceDrugsEditor:Mark as Unavailable / Damaged"
                              )}
                            </Button>
                          </div>
                        )}
                      {selectedPermittedActions.includes(
                        "returned_destroyed_action"
                      ) && (
                          <div>
                            <Button
                              type="default"
                              onClick={() =>
                                this.setState({
                                  confirmAction: {
                                    title: this.props.i18n.t(
                                      "NamespaceDrugsEditor:Mark as Returned / Destroyed"
                                    ),
                                    action: () =>
                                      this.bulkDrugAction(
                                        "returned_destroyed_action"
                                      ),
                                    selectedBulkVialNumbers: selectedBulkVialNumbers
                                  },
                                })
                              }
                            >
                              {this.props.i18n.t(
                                "NamespaceDrugsEditor:Mark as Returned / Destroyed"
                              )}
                            </Button>
                          </div>
                        )}
                      {selectedPermittedActions.includes(
                        "reset_orphaned_drug_action"
                      ) && (
                          <div>
                            <Button
                              type="default"
                              onClick={() =>
                                this.setState({
                                  confirmAction: {
                                    title: this.props.i18n.t(
                                      "NamespaceDrugsEditor:Reset the orphaned drug item to the first location in chain in quarantined status"
                                    ),
                                    action: () =>
                                      this.bulkDrugAction(
                                        "reset_orphaned_drug_action"
                                      ),
                                    selectedBulkVialNumbers: selectedBulkVialNumbers
                                  },
                                })
                              }
                            >
                              {this.props.i18n.t(
                                "NamespaceDrugsEditor:Reset orphaned drug"
                              )}
                            </Button>
                          </div>
                        )}
                    </div>
                  </div>
                )}
              </div>

              <div style={{position: "relative"}}>
                <Table
                  columns={columns}
                  dataSource={drugs}
                  rowKey="id"
                  loading={isLoading}
                  locale={{emptyText: isLoading ? " " : undefined}}
                  onChange={this.handleTableChange}
                  pagination={{
                    onShowSizeChange: (current, size) => {
                      this.setState({pageSize: size});
                    },
                    onChange: () => {
                      this.setState(() => ({checkedItems: []}));
                    },
                    current: currentPage,
                    total,
                    pageSize,
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "25", "50", "100"],
                    position: 'both',
                  }}
                />
              </div>

              <Modal
                visible={!!confirmAction}
                onCancel={this.onConfirmActionHide}
                footer={null}
              >
                {confirmAction && (
                  <div>
                    <h4 className="headline-default">
                      {this.props.i18n.t("Confirm action")}
                    </h4>
                    {get(confirmAction, 'drug') && (
                      <p>{this.props.i18n.t("NamespaceDrugsEditor: for drug:")}  &nbsp;
                        <span
                          className={classes.vialLink}
                          onClick={this.openDrugItem(get(confirmAction, 'drug'))}
                        >
                          {get(confirmAction, 'drug.vial_number')}
                        </span>
                          &nbsp;
                        <span>
                          &nbsp;
                          {this.props.i18n.t("NamespaceDrugsEditor: in status")}:  &nbsp;
                          <i>
                            {
                              mapped_statuses(this.props.i18n)[get(confirmAction, 'drug.drug_status')]
                            }
                          </i>
                        </span>
                      </p>
                    )}
                    {get(confirmAction, 'selectedBulkVialNumbers') && (
                      <p>{this.props.i18n.t("NamespaceDrugsEditor: for drug items")}: &nbsp;
                        {get(confirmAction, 'selectedBulkVialNumbers').length <= 10 && (
                          <span>{get(confirmAction, 'selectedBulkVialNumbers').map((item) => item + ", ")}</span>
                        )}
                        {get(confirmAction, 'selectedBulkVialNumbers').length > 10 && (
                          <span>{get(confirmAction, 'selectedBulkVialNumbers').length} {this.props.i18n.t("NamespaceDrugsEditor: drug items")}</span>
                        )}
                      </p>
                    )}

                    <p>
                      {this.props.i18n.t("Are you sure you want to perform action")}  &nbsp;
                      "<b>{confirmAction.title}</b>"?
                    </p>
                    <br/>
                      <Row gutter={24}>
                        <Col>
                          <label>
                            <b>{this.props.i18n.t('Action comment')}</b>
                              <Input.TextArea
                              onChange={(e) => {
                                this.setState({confirmAction: {...confirmAction, actionComment: e.target.value}});
                              }}
                              />
                          </label>
                        </Col>
                      </Row>
                    <br/>
                    <Button
                      type="primary"
                      onClick={async () => {
                        await confirmAction.action();
                        this.setState({confirmAction: null});
                      }}
                    >
                      {this.props.i18n.t("Yes")}
                    </Button>
                    &nbsp;
                    <Button onClick={this.onConfirmActionHide}>{this.props.i18n.t("No")}</Button>
                  </div>
                )}
              </Modal>
              <Modal
                visible={!!returnedByPatientDrug}
                onCancel={() => {
                  this.setState({
                    returnedByPatientDrug: null,
                  });
                }}
                footer={null}
              >
                {returnedByPatientDrug && (
                  <ReturnedByPatientForm
                    {...returnedByPatientDrug}
                    onSubmit={() => {
                      this.setState(
                        {
                          returnedByPatientDrug: null,
                        },
                        this.getDrugs
                      );
                    }}
                    onCancel={() => {
                      this.setState({
                        returnedByPatientDrug: null,
                      });
                    }}
                  />
                )}
              </Modal>
              <Modal
                visible={!!drugEdit}
                onCancel={this.onDrugEditHide}
                footer={null}
              >
                {drugEdit && (
                  <DrugForm
                    {...drugEdit}
                    isNew={drugEdit && !drugEdit.id}
                    onSubmit={this.onDrugEditSubmit}
                    onCancel={this.onDrugEditHide}
                    sitesList={centralSites}
                  />
                )}
              </Modal>

              <Modal
                visible={!!shipDrug}
                onCancel={this.shipDrugHide}
                footer={null}
              >
                {shipDrug && (
                  <DrugShipForm
                    onDrugShitClose={this.onDrugShitClose}
                    onSubmit={this.onDrugShipSubmit}
                    selectedToSite={this.state.selectedToSite}
                    siteListLoading={this.state.siteListLoading}
                    onFromChange={this.onFromChange}
                    onToChange={this.onToChange}
                    onCancel={this.shipDrugHide}
                    sitesListFrom={sitesListFrom}
                    sitesListTo={sitesListTo}
                  />
                )}
              </Modal>

              <Modal
                visible={!!isSendingToPatient}
                onCancel={this.sendingToPatientHide}
                footer={null}
              >
                {isSendingToPatient && (
                  <SendToPatientForm
                    drug={drug}
                    onSubmit={this.onDrugSendToPatientSubmit}
                    onCancel={this.sendingToPatientHide}
                  />
                )}
              </Modal>

              <Modal
                visible={!!drugItem}
                onCancel={this.closeDrugItem}
                footer={null}
                className={classes.eventModal}
              >
                {drugItem && (
                  <div>
                    <table className={classes.table}>
                      <thead>
                      <tr>
                        <td>{this.props.i18n.t("Event")}</td>
                        <td>
                          {this.props.i18n.t(
                            "NamespaceDrugsEditor:Is conducted"
                          )}
                        </td>
                        <td>{this.props.i18n.t("Status")}</td>
                        <td>{this.props.i18n.t("Comments")}</td>
                      </tr>
                      </thead>
                      <tbody>
                      {get(drugItem, "events_summary_report", []) &&
                        get(drugItem, "events_summary_report", []).map(
                          (item, i) => (
                            <tr key={i}>
                              <td>
                                {
                                  mapped_statuses(this.props.i18n)[item.event]
                                }
                              </td>
                              <td>{item.is_conducted ? this.props.i18n.t("Yes") : this.props.i18n.t("No")}</td>
                              <td>
                                {item.status === "green" && (
                                  <Icon
                                    type="check-square"
                                    className={classes.checkIcon}
                                  />
                                )}
                                {item.status === "red" && (
                                  <Icon
                                    type="warning"
                                    className={classes.warningIcon}
                                  />
                                )}
                                {item.status === "orange" && (
                                  <Icon
                                    type="clock-circle"
                                    className={classes.clockIcon}
                                  />
                                )}

                                {item.status === "missing" && (
                                  <Icon
                                    type="clock-circle"
                                    className={classes.clockIconMissing}
                                  />
                                )}
                                {item.status === "gray" && (
                                  <Icon
                                    type="clock-circle"
                                    className={classes.checkIconGray}
                                  />
                                )}
                                {item.status === "pending" && (
                                  <Icon
                                    type="clock-circle"
                                    className={classes.checkIconGray}
                                  />
                                )}
                              </td>
                              <td>{item.event_comments}</td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                )}

                  {get(drugItemHistory, "events", []) && (
                    <div>
                      <hr/>
                      <table className={classes.table}>
                        <thead>
                        <tr>
                          <td colSpan={5}><b>{this.props.i18n.t("Drug event history")}</b></td>
                        </tr>
                        <tr>
                          <td>{this.props.i18n.t("Event ")}</td>
                          <td>
                            {this.props.i18n.t(
                              "NamespaceDrugsEditor:Date"
                            )} (UTC)
                          </td>
                          <td>{this.props.i18n.t("Site name")}</td>
                          <td>{this.props.i18n.t("User")}</td>
                          <td>{this.props.i18n.t("Comments")}</td>
                        </tr>
                        </thead>
                        <tbody>

                        {get(drugItemHistory, "events", []) &&
                          get(drugItemHistory, "events", []).map(
                            (item, i) => (
                              <tr key={i}>
                                <td>
                                  {
                                    mapped_statuses(this.props.i18n)[item.event_type]
                                  }
                                </td>
                                <td>
                                  {item.scheduled_date
                                    ? `${moment
                                      .utc(item.scheduled_date)
                                      .format("YYYY-MM-DD hh:mm")}`
                                    : "No data"}{" "}
                                </td>
                                <td>
                                  {get(item, "site.name", "")}
                                </td>
                                <td>
                                  {get(item, "user.username", "")}
                                </td>
                                <td>
                                  {item.comments}
                                </td>

                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}

                {get(drugItemHistory, "transfers", []) && (
                    <div>

                      <hr/>
                      <table className={classes.table}>
                        <thead>
                        <tr>
                          <td colSpan={4}><b>{this.props.i18n.t("Drug transfer history")}</b></td>
                        </tr>
                        <tr>

                          <td>{this.props.i18n.t("NamespaceDrugsEditor:From site")}</td>
                          <td>-></td>
                          <td>{this.props.i18n.t("NamespaceDrugsEditor:To site")}</td>
                          <td>{this.props.i18n.t("NamespaceDrugsEditor:Total items")}</td>
                        </tr>
                        </thead>

                        <tbody>
                        {get(drugItemHistory, "transfers", []) &&
                          get(drugItemHistory, "transfers", []).map(
                            (item, i) => (
                              <tr key={i}>
                                <td>
                                  {get(item, "from_location.name", "")}
                                </td>
                                <td>
                                  ->
                                </td>
                                <td>
                                  {get(item, "to_location.name", "")}
                                </td>
                                <td>
                                  {item.total_vials}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
              </Modal>

            <Modal
              visible={isUpdateDrugExpiry}
              onCancel={() => {
                this.setState({
                  isUpdateDrugExpiry: false,
                });
              }}
              footer={null}
            >
              {isUpdateDrugExpiry && (
                <UpdateDrugExpiryForm
                  onSubmit={() => {
                    this.setState(
                      () => ({
                        isUpdateDrugExpiry: false,
                      }),
                      this.getDrugs
                    );
                  }}
                    onCancel={() => {
                      this.setState({isUpdateDrugExpiry: false});
                    }}
                  />
                )}
              </Modal>
          </Content>
        </Layout>
      </div>
  );
  }
  }

  const mapStateToProps = (state) => ({
    userTimezone: getUserTimezone(state),
      userShortTimezone
  :
    getUserShortTimezone(state),
      drugReadPermission
  :
    getDrugReadPermission(state),
      drugCreatePermission
  :
    getDrugCreatePermission(state),
      drugUpdatePermission
  :
    getDrugUpdatePermission(state),
      drugAccessPermissionDrugManagement
  :
    getDrugAccessPermissionDrugManagement(
      state
    ),
      drugRequestTransferPermission
  :
    getDrugRequestTransferPermission(state),
      drugBulkActionsPermission
  :
    getDrugBulkActionsPermission(state),
  drugAllowTransferFromFridgeToPatient: getDrugAllowTransferFromFridgeToPatient(
    state
  ),
  getDrugExpiryDateEditPermission: getDrugExpiryDateEditPermission(state),
});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(DrugsEditor))
);



// WEBPACK FOOTER //
// ./src/containers/DrugsEditor/DrugsEditor.js